<template>
  <section
    class="relative flex flex-col md:flex-row items-center justify-between bg-[#F1EEEA] py-16 px-6 md:px-20 overflow-hidden"
  >
    <!-- Texto a la izquierda -->
    <div class="text-center md:text-left max-w-2xl z-10">
      <p class="text-sm font-semibold mb-2 tracking-wide text-[#101541]">
        ACERCA DE INBROS
      </p>
      <h2
        class="text-4xl md:text-5xl font-bold text-[#101541] leading-snug mb-6"
      >
        Comprometidos con tu seguridad y tranquilidad
      </h2>
      <p class="text-base md:text-lg text-[#101541] mb-8 leading-relaxed">
        En INBROS trabajamos para proteger lo que más valoras. Ofrecemos
        soluciones de seguros personalizadas que se adaptan a tus necesidades,
        con un enfoque humano y cercano.
      </p>

      <RouterLink
        to="/about"
        class="inline-block bg-[#101541] text-white font-semibold py-3 px-6 rounded-lg hover:bg-[#0C1A91] transition"
      >
        Conócenos
      </RouterLink>
    </div>

    <!-- Imagen decorativa a la derecha -->
    <div class="relative mt-10 md:mt-0 w-full md:w-1/2 flex justify-end">
      <img
        src="@/assets/Tranquilidad.png"
        alt="Acerca de INBROS"
        class="max-w-sm md:max-w-md lg:max-w-lg w-full h-auto object-cover rounded-lg shadow-lg"
      />
    </div>
  </section>
</template>
